import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export default function CorporatePagination({ total, page, pageSize = 25, onPage, onPageSize, label = "records", disabled = false }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  return <footer className="cp-pagination">
    <span>{total ? `${((page - 1) * pageSize + 1).toLocaleString("en-GB")}–${Math.min(page * pageSize, total).toLocaleString("en-GB")} of ${total.toLocaleString("en-GB")}` : "0"} {label}</span>
    <div>{onPageSize && <label>Rows per page<select aria-label="Rows per page" disabled={disabled} value={pageSize} onChange={(event) => onPageSize(Number(event.target.value))}>{[25, 50, 100].map((size) => <option key={size}>{size}</option>)}</select></label>}
      <span>Page {page} of {pages}</span>
      <button type="button" className="cp-icon-button" aria-label="Previous page" disabled={disabled || page <= 1} onClick={() => onPage(page - 1)}><FiChevronLeft /></button>
      <button type="button" className="cp-icon-button" aria-label="Next page" disabled={disabled || page >= pages} onClick={() => onPage(page + 1)}><FiChevronRight /></button>
    </div>
  </footer>;
}
